import * as ActionTypes from '../../actions/types/website/ThemeActionTypes';

const initialState = {
  busy: false,
  list: [],
  themeDetails: {},
  homeTab: true,
  themesTab: false
};

const themesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.THEMES_REQUESTED: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.THEMES_RECEIVED: {
      const list = [...state.list];
      list.push(...action.payload.themes);
      return Object.assign({},
        state,
        { list },
        { busy: false }
      );
    }
    case ActionTypes.THEMES_RESET: {
      return initialState;
    }
    case ActionTypes.THEME_REQUESTED: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.THEME_RECEIVED: {
      return Object.assign({}, state, { themeDetails: action.payload });
    }
    default: return state;
  }
};

export default themesReducer;



// WEBPACK FOOTER //
// ./src/reducers/website/themes.js